import ReportsPanel from './reportsPanel';

export default ReportsPanel;
